import "./App.css";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Auth/Login/Login";
import DefaultLayout from "./components/Layout/DefaultLayout/DefaultLayout";
import Explore from "./components/Explore/Explore";
// import CalculateRefund from "./components/RefundModal/CalculateRefund/CalculateRefund";
import axios from "axios";
import { GlobalState } from "./context/GlobalContext";
import BusinessPlanning from "./components/BusinessPlanning/BusinessPlanning";
import BusinessPlanningProvider from "./context/BusinessPlanningContext";
import SupplierForm from "./components/SupplierPage/SupplierForm/SupplierForm";
import DefaultOpenLayout from "./components/Layout/DefaultOpenLayout/DefaultOpenLayout";
import AuthProvider from "./context/AuthContext";
import SupplierDashboard from "./components/SupplierPage/SupplierDashbord/SupplierDashboard";
import OwnProductionCostingDashboard from "./components/OwnProductionCosting/OwnProductionCostingDashbord/OwnProductionCostingDashboard";
// import CategoryLevelBp from "./components/BusinessPlanning/CategoryLevelBp/CategoryLevelBp";
import UcVsGynesis from "./components/UcVsGynesis/UcVsGynesis";
import Myntra_reco from "./components/MyntraReco";
import Store from "./components/BusinessPlanning/Store/Store";
import SubCategoryLevelBp from "./components/BusinessPlanning/Store/SubCategoryLevelBp/StoreLevelBp/SubCategoryLevelBp";
import EBOPayments from "components/EBOPayments/EBOPayments";
import Users from "components/Users/Users";
import Dashboard from "components/Layout/Dashboard/Dashboard";
import SupplierUser from "components/SupplierPage/SupplierUser/SupplierUser";
import DashboardSupplierUser from "components/SupplierPage/SupplierDashbord/SupplierUser/SupplierUser";
import { supplierDrawerElements, supplierUrlParamName } from "data/supplierPageData";

import { webDataDrawerElements, webDataParamName } from "data/radhamaniPageData";
import DashboardRWebData from "components/RadhamaniWebData/RadhamaniWebData";
import ChangePassword from "components/Auth/ChangePassword/ChangePassword";
import { rootProtectedPath, services } from "data/authData";
import { itemMasterDrawerElements, itemMasterTabParamName } from "data/itemMasterData";
import ItemMasterDashboard from "components/ItemMaster/ItemMaster";

import DataHub from "components/DataHub/DataHub";
import { DataHubDrawerElements, DataHubTabParamName } from "data/DataHubData";
import { myntra_reco_drawer, myntraRecoUrlParamName } from "data/myntraRecoData";
import LoadingScreen from "components/commonComponents/LoadingScreen";
import DataHubStoreView from "components/DataHub/DataHubStore/DataHubStoreView";
import EboStoresHome from "components/EboStoreV4/EboStoreV4";
import EboStoresList from "components/EboStoreV4/EboStoresList/EboStoresList";
import EboStoreProvider from "context/EboStoreContext";
import { eboAllStoresPage, eboSelectedStorePage } from "components/EboStoreV4/data";
import SelectedStoreDashboard from "components/EboStoreV4/SelectedStoreDashboard/SelectedStoreDashboard";
import { eboStoreDrawerElements } from "components/EboStoreV4/SelectedStoreDashboard/data";
import MboLfsHome from "components/MboLfsV2/MboLfsV2";
import { mbolfsAllStoresPage, mbolfsSelectedStorePage } from "components/MboLfsV2/data";
import MboLfsStoreList from "components/MboLfsV2/MboLfsStoreList/MboLfsStoreList";
import { mboStoreDrawerElements } from "components/MboLfsV2/MboSelectedStoreDashboard/data";
import MboSelectedStoreDashboard from "components/MboLfsV2/MboSelectedStoreDashboard/MboSelectedStoreDashboard.js";
import DataHubWarehouseView from "components/DataHub/DataHubWH/DataHubWHView";
import ForgotPasswordReset from "components/Auth/ForgotPasswordReset/ForgotPasswordReset";
import { replenishmentDrawerElements, replenishmentParamName } from "components/ReplenishmentDashboard/data";
import ReplenishmentDashboard from "components/ReplenishmentDashboard/ReplenishmentDashboard";
import MboPaymentWorking from "components/MboPaymentWorking/MboPaymentWorking";
import { mboPaymentDashboardServices } from "components/MboPaymentWorking/data";
import DashboardWithMiniCollapsableDrawer from "components/Layout/DashboardWithMiniCollapsableDrawer/DashboardWithMiniCollapsableDrawer";
import MboPaymentProvider from "context/MboPaymentContext";
import MboPaymentWorkingExplore from "components/MboPaymentWorking/MboPaymentWorkingExplore/MboPaymentWorkingExplore";
import ReplenishmentProvider from "context/ReplenishmentContext.js";
// import FormDialog from "components/EboStoreV3/Form/Form";

import DesignerWorkspace from "components/DesignerWorkspace/DesignerWorkspace";
import FinanceWorkspace from "components/FinanceWorkspace/FinanceWorkspace";
import { generateReportsRoutesFromServiceTree, reportsDashboardSideNavList } from "components/Reports/data";
import ReportsProvider from "context/ReportsContext";
import Reports from "components/Reports/Reports";
import { generateReplenishmentRoutesFromServiceTree } from "data/replenishmentData";
import HRWorkspace from "components/HRWorkspace/HRWorkspace";
import MboSaleWorkspace from "components/MboSaleWorkspace/MboSaleWorkspace";
import OpsReportWorkspace from "components/OpsReportWorkspace/OpsReportWorkspace";
import { adyogiReportsDashboardSideNavList, generateAdyogiReportsRoutesFromServiceTree } from "components/AdyogiExternalReports/data";
import { generateCustomQueriesRoutesFromServiceTree } from "data/customQueriesData";
import { customQuereiesDrawerElements, planningSaleQueryPath } from "components/CustomQueriesDashboard/data";
import CustomQueriesProvider from "context/CustomQueriesContext";
import { audienceDrawerElements, audienceFacebookPagePath } from "components/AudienceDashboard/data";
import AudienceDashboardProvider from "context/AudienceDashboardContext";
import { generateAudienceRoutesFromServiceTree } from "data/AudienceDashboardData";
import { generateGujratSaleRoutesFromServiceTree, gujratSaleExternalDashboardSideNavList } from "components/GujratSaleExternal/data";
import AopTracker from "components/AopTracker/AopTracker";
import Exclusion from "components/Exclusion/Exclusion.js";
import Sora from "components/Sora/Sora";
import SalesOrderList from "components/Sora/components/SalesOrderList";
import SalesOrderDetail from "components/Sora/components/SalesOrderDetail";
import SoraDashboard from "components/Sora/components/Dashboard";
import ReturnOrderList from "components/Sora/components/ReturnOrderList";
import ReturnModule from "components/ReturnModule/ReturnModule";
import ReturnModuleDashboard from "components/ReturnModule/components/Dashboard";
import AxisRouteGuard from "components/WHAllocation/AxisRouteGuard";
import ShippingProviderRecoProvider from "context/shippingProviderRecoContext";
import { shippingPartnerDrawerElements } from "components/ShippingPartnerReco/data";
import { generateShippingPartnerRecoRoutesFromServiceTree } from "data/shippingPartnerRecoData";
import DesignerWorkspaceV2 from "components/DesignerWorkspace/DesignerWorkspaceV2";
import PosRecoProvider from "context/PosRecoContext";
import { generatePosRoutesFromServiceTree, posDashboardSideNavList } from "components/POSReco/data";
import FabricSourcingWorkspace from "components/FabricSourcingWorkspace/FabricSourcingWorkspace";

function App() {
	const { snackBar, snackBarOpen, setSnackBarOpen } = GlobalState();
	axios.defaults.baseURL = process.env.REACT_APP_API_URL;
	axios.defaults.headers["Content-Type"] = `application/json`;
	axios.interceptors.response.use(
		(response) => {
			// console.log("✅ Response:", response.status, response.config.url);
			return response;
		},
		(error) => {
			if (error.response?.status === 401) {
				console.warn("🔒 Unauthorized! Redirecting to login...");
				localStorage.removeItem("token");
				//   window.location.href = "/login";
				window.location.reload(true);
			}
			return Promise.reject(error);
		},
	);

	return (
		<Box className="App">
			{/* for alert messages */}
			<LoadingScreen />
			<Snackbar
				open={snackBarOpen}
				autoHideDuration={4000}
				onClose={() => setSnackBarOpen(false)}
				anchorOrigin={snackBar.anchorOrigin}>
				<Alert onClose={() => setSnackBarOpen(false)} severity={snackBar.severity} sx={{ width: "100%" }}>
					{snackBar.message}
				</Alert>
			</Snackbar>

			<Routes>
				<Route path="/" element={<Login />} />
				{/* only explore has authentication */}
				<Route
					path={rootProtectedPath}
					element={
						<AuthProvider>
							<DefaultLayout />
						</AuthProvider>
					}>
					<Route index element={<Explore />} />
					{/* <Route path="calc_refund_RM" element={<CalculateRefund />} /> */}
					<Route path={services.supplier_dashboard.path}>
						<Route index element={<SupplierDashboard />} />
						<Route
							path="supplier_info"
							element={
								<Dashboard drawerList={supplierDrawerElements} searchParamName={supplierUrlParamName} navSpace={0} />
							}>
							<Route index element={<DashboardSupplierUser />} />
						</Route>
					</Route>
					{/* <Route path={services.ebo_stores.path} element={<StoreProvider />} /> */}
					<Route path={services.ebo_stores.path} element={<EboStoreProvider />}>
						<Route index element={<EboStoresHome />} />
						<Route path={eboAllStoresPage} element={<EboStoresList />} />
						{/* <Route path={eboSelectedStorePage} element={<SelectedStore />} /> */}
						<Route
							path={eboSelectedStorePage}
							element={
								<Dashboard drawerList={eboStoreDrawerElements} searchParamName={webDataParamName} navSpace={0} />
							}>
							<Route index element={<SelectedStoreDashboard />} />
						</Route>
					</Route>

					<Route path={services.mbo_stores.path}>
						<Route index element={<MboLfsHome />} />
						<Route path={mbolfsAllStoresPage} element={<MboLfsStoreList />} />
						<Route
							path={mbolfsSelectedStorePage}
							element={
								<Dashboard drawerList={mboStoreDrawerElements} searchParamName={webDataParamName} navSpace={0} />
							}>
							<Route index element={<MboSelectedStoreDashboard />} />
						</Route>
					</Route>

					<Route path={services.production_costing.path} element={<OwnProductionCostingDashboard />} />

					<Route path={services.uc_vs_ginesys.path} element={<UcVsGynesis />} />
					<Route path={services.exclusions.path} element={<Exclusion />} />
					<Route path={services.aop.path} element={<AopTracker />} />

					<Route element={<ReportsProvider />} path="reports">
						<Route index element={<Navigate to="SALE/thor_live_sale" replace />} />
						{Object.keys(reportsDashboardSideNavList).map((key) =>
							generateReportsRoutesFromServiceTree(reportsDashboardSideNavList[key], "reports"),
						)}
					</Route>
					<Route element={<PosRecoProvider />} path="pos_reco">
						{Object.keys(posDashboardSideNavList).map((key) =>
							generatePosRoutesFromServiceTree(posDashboardSideNavList[key], "pos_reco"),
						)}
					</Route>
					<Route element={<ReplenishmentProvider />} path={services.replenishment.path}>
						{Object.keys(replenishmentDrawerElements).map((key) =>
							generateReplenishmentRoutesFromServiceTree(replenishmentDrawerElements[key], services.replenishment.path),
						)}
					</Route>
					<Route element={<ShippingProviderRecoProvider />} path={services.shipping_partner_reco.path}>
						{Object.keys(shippingPartnerDrawerElements).map((key) =>
							generateShippingPartnerRecoRoutesFromServiceTree(
								shippingPartnerDrawerElements[key],
								services.shipping_partner_reco.path,
							),
						)}
					</Route>
					<Route element={<CustomQueriesProvider />} path={services.custom_queries.path}>
						<Route index element={<Navigate to={planningSaleQueryPath} />} />
						{Object.keys(customQuereiesDrawerElements).map((key) =>
							generateCustomQueriesRoutesFromServiceTree(
								customQuereiesDrawerElements[key],
								services.custom_queries.path,
							),
						)}
					</Route>
					<Route element={<AudienceDashboardProvider />} path={services.audience.path}>
						<Route index element={<Navigate to={audienceFacebookPagePath} />} />
						{Object.keys(audienceDrawerElements).map((key) =>
							generateAudienceRoutesFromServiceTree(audienceDrawerElements[key], services.audience.path),
						)}
					</Route>

					<Route path={services.ebo_payments.path} element={<EBOPayments />} />
					<Route path={services.users.path} element={<Users />} />
					<Route
						path={services.data_hub.path}
						element={<Dashboard drawerList={DataHubDrawerElements} searchParamName={DataHubTabParamName} navSpace={0} />}>
						<Route index element={<DataHub />} />
					</Route>
					<Route
						path={services.radhamani_web_data.path}
						element={<Dashboard drawerList={webDataDrawerElements} searchParamName={webDataParamName} navSpace={0} />}>
						<Route index element={<DashboardRWebData />} />
					</Route>

					<Route
						path={services.item_master.path}
						element={
							<Dashboard drawerList={itemMasterDrawerElements} searchParamName={itemMasterTabParamName} navSpace={0} />
						}>
						<Route index element={<ItemMasterDashboard />} />
					</Route>
					<Route path={services.designer_workspace.path} element={<DesignerWorkspaceV2 />} />
					<Route path={services.fabric_sourcing_workspace.path} element={<FabricSourcingWorkspace />} />
					<Route path={services.finance_workspace.path} element={<FinanceWorkspace />} />
					<Route path={services.hr_workspace.path} element={<HRWorkspace />} />
					<Route path={services.mbo_sale_workspace.path} element={<MboSaleWorkspace />} />
					<Route path={services.ops_report_workspace.path} element={<OpsReportWorkspace />} />
					<Route
						path={services.online_reco.path}
						element={
							<Dashboard
								drawerList={myntra_reco_drawer}
								searchParamName={myntraRecoUrlParamName}
								navSpace={0}
								drawerWidth={150}
							/>
						}>
						<Route index element={<Myntra_reco />} />
					</Route>
					<Route path={services.business_plan.path} element={<BusinessPlanningProvider />}>
						<Route index element={<BusinessPlanning />} />
						<Route path="store" element={<Store />} />
						<Route path="category" element={<SubCategoryLevelBp />} />
					</Route>

					<Route path={services.discount_master.path}>
						<Route index element={<MboPaymentWorkingExplore />} />
						<Route element={<MboPaymentProvider />}>
							{/* </Route> */}
							{Object.keys(mboPaymentDashboardServices)
								.reduce((acc, row) => {
									const service = mboPaymentDashboardServices[row];
									if (service?.types && typeof service?.types === "object") {
										Object.keys(service.types).forEach((key) => {
											acc.push(service.types[key]);
										});
									} else acc.push(service);
									return acc;
								}, [])
								.map((row) => {
									return (
										<Route
											path={row.key}
											key={row.key}
											element={
												<DashboardWithMiniCollapsableDrawer
													drawerList={mboPaymentDashboardServices}
													searchParamName={"tab"}
													navSpace={0}
													service={row}
													pathName={row.key}
													rootPath={services.discount_master.path}
												/>
											}>
											<Route index element={<MboPaymentWorking />} />
										</Route>
									);
								})}
						</Route>
					</Route>

					{/* sora */}
					<Route path={services.sora.path} element={<Sora />}>
						<Route index element={<SoraDashboard />} />
						<Route path="sales-orders" element={<SalesOrderList />} />
						<Route path="sales-order/:soNo" element={<SalesOrderDetail />} />
						<Route path="return-orders" element={<ReturnOrderList />} />
					</Route>

					{/* return module */}
					<Route path={services.return_module.path} element={<ReturnModule />}>
						<Route index element={<ReturnModuleDashboard />} />
					</Route>

					{/* AXIS — requires admin or service-level role.AXIS */}
					<Route path={services.wh_allocation.path} element={<AxisRouteGuard />} />
				</Route>

				{/* Routes with no auth */}
				<Route path="open" element={<DefaultOpenLayout />}>
					<Route index element={<SupplierForm />} />
					<Route path="supplier" element={<SupplierForm />} />
				</Route>

				<Route path="change_password" element={<ChangePassword />} />
				<Route path="password-reset/:token" element={<DefaultOpenLayout />}>
					<Route index element={<ForgotPasswordReset />} />
				</Route>
				<Route path="external">
					<Route
						path="supplier"
						element={
							<AuthProvider>
								<Dashboard drawerList={supplierDrawerElements} searchParamName={supplierUrlParamName} navSpace={10} />
							</AuthProvider>
						}>
						<Route index element={<SupplierUser />} />
					</Route>
					<Route
						path="store"
						element={
							<AuthProvider>
								<DefaultLayout />
								{/* <DataHubStoreView /> */}
							</AuthProvider>
						}>
						<Route index element={<DataHubStoreView />} />
					</Route>
					<Route
						path="warehouse"
						element={
							<AuthProvider>
								<DefaultLayout />
								{/* <DataHubStoreView /> */}
							</AuthProvider>
						}>
						<Route index element={<DataHubWarehouseView />} />
					</Route>
					<Route
						path="ADYOGI"
						element={
							<AuthProvider>
								<DefaultLayout />
							</AuthProvider>
						}>
						<Route index element={<Navigate to="reports" replace />} />
						{/* {generateAdyogiReportsRoutesFromServiceTree(adyogiReportsDashboardSideNavList, "reports")} */}
						<Route element={<ReportsProvider />} path="reports">
							<Route index element={<Navigate to={adyogiReportsDashboardSideNavList.shopify_live_sale.key} replace />} />

							{Object.keys(adyogiReportsDashboardSideNavList).map((key) =>
								generateAdyogiReportsRoutesFromServiceTree(adyogiReportsDashboardSideNavList[key], "reports"),
							)}
						</Route>
					</Route>
					<Route
						path="GUJRAT_SALE"
						element={
							<AuthProvider>
								<DefaultLayout />
							</AuthProvider>
						}>
						<Route index element={<Navigate to="custom_sale_report" replace />} />

						<Route element={<ReportsProvider />} path="custom_sale_report">
							<Route
								index
								element={<Navigate to={gujratSaleExternalDashboardSideNavList.ebo_sale_gujrat.key} replace />}
							/>

							{Object.keys(gujratSaleExternalDashboardSideNavList).map((key) =>
								generateGujratSaleRoutesFromServiceTree(
									gujratSaleExternalDashboardSideNavList[key],
									"custom_sale_report",
								),
							)}
						</Route>
					</Route>
				</Route>
			</Routes>
		</Box>
	);
}

export default App;
